import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ThemeProvider";

// Pages
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ChildrenPage from "@/pages/ChildrenPage";
import WorkshopsPage from "@/pages/WorkshopsPage";
import BookingsPage from "@/pages/BookingsPage";
import VerifyChildPage from "@/pages/VerifyChildPage";
import RegisterChildPage from "@/pages/RegisterChildPage";
import SelectWorkshopPage from "@/pages/SelectWorkshopPage";

// Auth guard component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="workshop-theme">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verificar" element={<VerifyChildPage />} />
          <Route path="/cadastrar" element={<RegisterChildPage />} />
          <Route path="/agendar/:childId" element={<SelectWorkshopPage />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/admin/criancas" element={<ProtectedRoute><ChildrenPage /></ProtectedRoute>} />
          <Route path="/admin/workshops" element={<ProtectedRoute><WorkshopsPage /></ProtectedRoute>} />
          <Route path="/admin/agendamentos" element={<ProtectedRoute><BookingsPage /></ProtectedRoute>} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </ThemeProvider>
  );
}

export default App;
